/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { BulkUpdateMonthlyUsageLimit200ResponseInnerAvailableMerchantCategoriesInner } from './bulk-update-monthly-usage-limit200-response-inner-available-merchant-categories-inner';
// May contain unused imports in some cases
// @ts-ignore
import { BulkUpdateMonthlyUsageLimit200ResponseInnerReissue } from './bulk-update-monthly-usage-limit200-response-inner-reissue';
// May contain unused imports in some cases
// @ts-ignore
import { BulkUpdateMonthlyUsageLimit200ResponseInnerUser } from './bulk-update-monthly-usage-limit200-response-inner-user';
// May contain unused imports in some cases
// @ts-ignore
import { BulkUpdateMonthlyUsageLimit200ResponseInnerUserAccountGroup } from './bulk-update-monthly-usage-limit200-response-inner-user-account-group';

/**
 * 
 * @export
 * @interface BulkUpdateMonthlyUsageLimit200ResponseInner
 */
export interface BulkUpdateMonthlyUsageLimit200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'isFraudLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'isCreditCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'isOnDemand': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'isPhysicalStorePaymentDisabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'userAccountId': string;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'transactionUpperLimit': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'availableCurrencies': Array<BulkUpdateMonthlyUsageLimit200ResponseInnerAvailableCurrenciesEnum>;
    /**
     * 
     * @type {Array<BulkUpdateMonthlyUsageLimit200ResponseInnerAvailableMerchantCategoriesInner>}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'availableMerchantCategories': Array<BulkUpdateMonthlyUsageLimit200ResponseInnerAvailableMerchantCategoriesInner> | null;
    /**
     * 
     * @type {BulkUpdateMonthlyUsageLimit200ResponseInnerUser}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'user': BulkUpdateMonthlyUsageLimit200ResponseInnerUser;
    /**
     * 
     * @type {BulkUpdateMonthlyUsageLimit200ResponseInnerUserAccountGroup}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'userAccountGroup'?: BulkUpdateMonthlyUsageLimit200ResponseInnerUserAccountGroup | null;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'monthlyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'monthlyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'dailyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'dailyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'totalUsageAmount': number;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'totalUsageAmountLimit': number | null;
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     * @deprecated
     */
    'expiredDate': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     * @deprecated
     */
    'isRenewalProcessing': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     * @deprecated
     */
    'isAutoRenewalOnExpiration': boolean;
    /**
     * 
     * @type {BulkUpdateMonthlyUsageLimit200ResponseInnerReissue}
     * @memberof BulkUpdateMonthlyUsageLimit200ResponseInner
     */
    'reissue'?: BulkUpdateMonthlyUsageLimit200ResponseInnerReissue | null;
}

export const BulkUpdateMonthlyUsageLimit200ResponseInnerAvailableCurrenciesEnum = {
    jpy: 'JPY',
    usd: 'USD',
    gbp: 'GBP',
    eur: 'EUR',
    sgd: 'SGD',
    aud: 'AUD',
    cny: 'CNY',
    hkd: 'HKD',
    idr: 'IDR',
    krw: 'KRW',
    nzd: 'NZD',
    php: 'PHP',
    rub: 'RUB',
    vnd: 'VND',
    inr: 'INR',
    thb: 'THB',
    lak: 'LAK',
    myr: 'MYR',
    twd: 'TWD',
    chf: 'CHF',
    cad: 'CAD',
    mxn: 'MXN',
    nok: 'NOK',
    huf: 'HUF',
    hrk: 'HRK',
    czk: 'CZK',
    dkk: 'DKK',
    isk: 'ISK',
    mdl: 'MDL',
    sek: 'SEK',
    mkd: 'MKD',
    rsd: 'RSD',
    ron: 'RON',
    bgn: 'BGN',
    bam: 'BAM',
    pln: 'PLN',
    mad: 'MAD',
    zar: 'ZAR',
    rwf: 'RWF',
    kes: 'KES',
    ngn: 'NGN',
    aed: 'AED',
    sar: 'SAR',
    egp: 'EGP',
    qar: 'QAR',
    omr: 'OMR',
    ils: 'ILS',
    try: 'TRY',
    kzt: 'KZT',
    cop: 'COP',
    gtq: 'GTQ'
} as const;

export type BulkUpdateMonthlyUsageLimit200ResponseInnerAvailableCurrenciesEnum = typeof BulkUpdateMonthlyUsageLimit200ResponseInnerAvailableCurrenciesEnum[keyof typeof BulkUpdateMonthlyUsageLimit200ResponseInnerAvailableCurrenciesEnum];


